/**
 * Co-Producer / Touring Partner / Project Partner form
 */

// import $ from 'jquery';
import Vue from 'vue';
import $ from 'jquery';
import _ from 'lodash';
import VeeValidate, { Validator } from 'vee-validate';
import refreshToken from '../mixins/refresh-token';

Vue.use(VeeValidate);

Validator.extend('positive', {
    getMessage: field => 'The ' + field + ' must be a positive number.',
    validate: value => value ? /^\+?([0-9]+)?((\.|,)[0-9]{1,2})?$/.test(value) : true
});

Validator.extend('equal', {
    validate: function (value, args) {
        return parseInt(value) === parseInt(args[0]);
    }
});

const formBudgetComponentConfig = {
    /**
     * Component name
     * @type {String}
     */
    name: 'form-budget',

    props: [
        'token',
        'previous',
        'action',
        'id',
        'projectData',
        'next',
        'readOnly',
        'fedora',
        'categorie',
        'errorBags'
    ],

    mixins: [ refreshToken ],

    /**
     * Component data
     * @return {Object}
     */
    data () {
        const dataObject = {
            project: {
                overall: {},
                contribution: {},
                financing: {}
            },
            canSubmit: true,
            tokenVal: null
        };

        return dataObject;
    },

    methods: {
        scrollToFirstError () {
            let fieldName = this.errors.items[0].field;

            $([document.documentElement, document.body]).animate({
                scrollTop: $('[name="' + fieldName + '"]').parent()
                    .offset().top - 130
            }, 500);
        },
        validateForm (e) {
            e.preventDefault();
            // if (this.collaboratings.length > 0) {
            this.canSubmit = true;
            const field1 = this.$validator.fields.find({ name: 'overall[total_administration][other_specify]' });
            const field2 = this.$validator.fields.find({ name: 'overall[total_production][other_specify]' });
            const field3 = this.$validator.fields.find({ name: 'overall[other_specify_creation]' });
            const field4 = this.$validator.fields.find({ name: 'overall[other_specify_performer]' });

            if (field1) {
                this.manuallyValidate(field1, this.project.overall.total_administration.other, this.project.overall.total_administration.other_specify);
            }
            if (field2) {
                this.manuallyValidate(field2, this.project.overall.total_production.other, this.project.overall.total_production.other_specify);
            }
            if (field3) {
                this.manuallyValidate(field3, this.project.overall.total_creation, this.project.overall.other_specify_creation);
            }
            if (field4) {
                this.manuallyValidate(field4, this.project.overall.total_performer, this.project.overall.other_specify_performer);
            }

            if (this.canSubmit) {
                this.$validator.validateAll().then((valid) => {
                    if (valid) {
                        let btnSpinner = $('.btn--spinner', e.target);

                        btnSpinner.addClass('right-spin');
                        e.target.submit();
                    } else {
                        this.scrollToFirstError();
                    }
                })
                    .catch(() => {
                        return false;
                    });
            }
        },
        manuallyValidate (field, numberValue, textValue) {
            if (numberValue !== undefined && parseFloat(numberValue) > 0) {
                if (textValue === undefined ||
                    !textValue ||
                    !textValue.length) {
                    this.$validator.errors.add({
                        id: field.name,
                        field: field.name,
                        msg: 'Required',
                        scope: this.$options.scope
                    });

                    field.setFlags({
                        invalid: true,
                        valid: false,
                        validated: true
                    });

                    this.canSubmit = false;

                    this.scrollToFirstError();
                }
            } else {
                this.$validator.errors.remove(field.name, field.scope);
            }
        },
        percentage (value, rapport) {
            if (value >= 0) {
                if (rapport > 0) {
                    let percent = (value * 100) / rapport;

                    return percent.toFixed(2);
                } else {
                    let zero = 0;

                    return zero.toFixed(2);
                }
            } else {
                let zero = 0;

                return zero.toFixed(2);
            }
        }
    },

    /**
     * Created event handler
     * @return {Void}
     */
    created () {
        this.project = this.projectData;
        if (this.project.financing === undefined) {
            this.project.financing = {
                value: {},
                text: {}
                // self_financing: 0.00,
                // ticket_sales: 0.00,
                // public_support: 0.00,
                // foundation: 0.00,
                // corporate_giving: 0.00,
                // legacy_giving: 0.00,
                // individual_giving: 0.00,
                // crowdfunding: 0.00,
                // fedora: 0.00,
                // other: 0.00
            };
        }
        this.tokenVal = this.token;
    },

    mounted () {
        _.each(this.errorBags, (value, fieldname) => {
            if (this.teamMemberError) {
                this.project.teamMemberError = true;
            } else {
                const field = this.$validator.fields.find({ name: fieldname });

                this.$validator.errors.add({
                    id: field.name,
                    field: field.name,
                    msg: value[0],
                    scope: this.$options.scope
                });

                field.setFlags({
                    invalid: true,
                    valid: false,
                    validated: true
                });
            }
        });

        if (this.errors.items[0] !== undefined) {
            let fieldName = this.errors.items[0].field;

            $([document.documentElement, document.body]).animate({
                scrollTop: $('[name="' + fieldName + '"]').parent()
                    .offset().top - 130
            }, 500);
        }
    },

    computed: {
        overallTotalProduction: function () {
            let sum = 0;

            _.each(this.project.overall.total_production, value => {
                if (!value) {
                    value = 0;
                }
                if (value >= 0) {
                    sum += parseFloat(value);
                }
            });

            return sum.toFixed(2);
        },
        overallTotalAdministration: function () {
            let sum = 0;

            _.each(this.project.overall.total_administration, value => {
                if (!value) {
                    value = 0;
                }
                if (value >= 0) {
                    sum += parseFloat(value);
                }
            });

            return sum.toFixed(2);
        },
        overallTotal: function () {
            let total = parseFloat(this.overallTotalProduction) +
                parseFloat(this.overallTotalAdministration) +
                parseFloat(this.project.overall.total_communication_costs === undefined ? 0 : this.project.overall.total_communication_costs) +
                parseFloat(this.project.overall.total_creation === undefined ? 0 : this.project.overall.total_creation) +
                parseFloat(this.project.overall.total_project_management_fees === undefined ? 0 : this.project.overall.total_project_management_fees) +
                parseFloat(this.project.overall.total_performer === undefined ? 0 : this.project.overall.total_performer);

            return parseFloat(total).toFixed(2);
        },
        contributionTotalProduction: function () {
            let sum = 0;

            _.each(this.project.contribution.total_production, value => {
                if (!value) {
                    value = 0;
                }
                if (value >= 0) {
                    sum += parseFloat(value);
                }
            });

            return sum.toFixed(2);
        },
        contributionTotalAdministration: function () {
            let sum = 0;

            _.each(this.project.contribution.total_administration, value => {
                if (!value) {
                    value = 0;
                }
                if (value >= 0) {
                    sum += parseFloat(value);
                }
            });

            return sum.toFixed(2);
        },

        contributionTotal: function () {
            let total = parseFloat(this.contributionTotalAdministration) +
                parseFloat(this.contributionTotalProduction) +
                parseFloat(this.project.contribution.total_creation === undefined ? 0 : this.project.contribution.total_creation) +
                parseFloat(this.project.contribution.total_performer === undefined ? 0 : this.project.contribution.total_performer);

            return parseFloat(total).toFixed(2);
        },

        nextStageOverallProjetCostTotal: function () {
            let total = parseFloat(this.overallTotalProduction) - parseFloat(this.nextStageAdminCostsTotal);

            return parseFloat(total).toFixed(2);
        },

        nextStageAdminCostsTotal: function () {
            let total = parseFloat(this.project.overall.total_production.project_coordination === undefined ? 0 : this.project.overall.total_production.project_coordination) +
                parseFloat(this.project.overall.total_production.inhouse_staff === undefined ? 0 : this.project.overall.total_production.inhouse_staff) +
                parseFloat(this.project.overall.total_production.other_next === undefined ? 0 : this.project.overall.total_production.other_next);

            return parseFloat(total).toFixed(2);
        },

        financingTotal: function () {
            let sum = 0;

            _.each(this.project.financing.value, value => {
                if (!value) {
                    value = 0;
                }
                if (parseFloat(value) >= 0) {
                    sum += parseFloat(value);
                }
            });

            if (this.categorie !== 'nextstage') {
                sum += parseFloat(this.fedora);
            }

            return sum.toFixed(2);
        }
    }

};

const formBudgetComponent = Vue.extend(formBudgetComponentConfig);

export default formBudgetComponent;
